// extracted by mini-css-extract-plugin
export default {"listTableOuter":"whitelist_listTableOuter__jHSF9"};